// src/views/Facturacion/Clientes/FacturaClienteForm.jsx
import React, { useEffect, useState } from "react";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import { appFetchJson } from "../../../utils/http";
import apiRoutes from "../../../api/apiRoutes";

/**
 * Crear Liquidación (Semanas)
 * Modal estándar FLPA
 */
export default function CrearLiquidacionSemanas({
  onClose = () => {},
  onSaved = () => {},
}) {
  // =========================
  // ESTADO
  // =========================
  const [descripcion, setDescripcion] = useState("");

  // =========================
  // ESC PARA CERRAR
  // =========================
  useEffect(() => {
    const esc = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [onClose]);

  // =========================
  // VALIDACIÓN
  // =========================
  const isValid = descripcion.trim() !== "";

  // =========================
  // GUARDAR
  // =========================
  const handleGuardar = async () => {
    try {
      const payload = {
        descripcion: descripcion.trim(),
      };

      await appFetchJson(
        apiRoutes.liquidacion.create(),
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
        {
          showSuccess: true,
          successMessage: "Liquidación creada correctamente",
          onSuccessClose: () => onSaved(),
        }
      );
    } catch (e) {
      console.error("Error al crear liquidación", e);
    }
  };

  // =========================
  // RENDER
  // =========================
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal-panel-lg"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">
            Introduzca los datos de la Liquidación
          </h2>
          <span className="text-sm text-red-600">
            (*) Campos obligatorios
          </span>
        </div>

        {/* BODY */}
        <div className="modal-body">
          <div className="border rounded-lg bg-white">
            <div className="px-6 py-6 space-y-4">

              {/* DESCRIPCIÓN */}
              <FormRow label="Descripción:" required>
                <div className="max-w-md">
                  <input
                    type="text"
                    className="input"
                    value={descripcion}
                    onChange={(e) => setDescripcion(e.target.value)}
                    maxLength={60}
                    autoFocus
                  />
                </div>
              </FormRow>

            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar
              label="Guardar"
              isValid={isValid}
              onClick={handleGuardar}
            />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}

/* =========================
   COMPONENTES AUX
========================= */

function FormRow({ label, required, children }) {
  return (
    <div className="grid grid-cols-[200px_1fr] items-center gap-3 max-w-3xl">
      <label className="text-right">
        {label}
        {required && <span className="text-red-600 ml-1">*</span>}
      </label>
      {children}
    </div>
  );
}
